import { MapUtils } from '../../utility/map-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../dto/dto.js';

export class FeaturedOption extends DataModel {
  static readonly TYPE_ID: string = '6f49c7d4a6c747e38a754d12030e6f0d';

  constructor(
    public readonly featured: boolean,
    public readonly renderOrder: number
  ) {
    super();
  }

  get $typeId(): string {
    return FeaturedOption.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): FeaturedOption {
    return new FeaturedOption(
        MapUtils.get<boolean>(map, 'featured'),
        MapUtils.get<number>(map, 'renderOrder'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'featured': this.featured,
      'renderOrder': this.renderOrder,
    };
  }

  clone(): this {
    return new FeaturedOption(
        this.featured,
        this.renderOrder,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.featured === this.featured &&
        other.renderOrder === this.renderOrder;
  }
}

export class FeaturedOptionBuilder extends DataModelBuilder<FeaturedOption> {
  build(context: SerializationContext, map: SerializedData): FeaturedOption {
    return FeaturedOption.fromMap(context, map);
  }
}
